import { useFormikContext } from 'formik';

import { EdgeCheckinIntervalField } from '@/react/edge/components/EdgeCheckInIntervalField';
import {
  EdgeAsyncIntervalsForm,
  EdgeAsyncIntervalsValues,
} from '@/react/edge/components/EdgeAsyncIntervalsForm';

import { FormSection } from '@@/form-components/FormSection';

interface Props {
  asyncMode: boolean;
  readonly?: boolean;
}

export function CheckinIntervalsSection({
  asyncMode,
  readonly = false,
}: Props) {
  const { values, setFieldValue } = useFormikContext<{
    pollFrequency: number;
    edge: EdgeAsyncIntervalsValues;
  }>();

  return (
    <FormSection title="Check-in Intervals">
      {asyncMode ? (
        <EdgeAsyncIntervalsForm
          values={values.edge}
          readonly={readonly}
          onChange={(values) => setFieldValue('edge', values)}
        />
      ) : (
        <EdgeCheckinIntervalField
          readonly={readonly}
          onChange={(value) => setFieldValue('pollFrequency', value)}
          value={values.pollFrequency}
        />
      )}
    </FormSection>
  );
}
